<template>
    <div class="flex justify-center h-screen flex items-center">
        <div class="flex">
            <LoaderComponent />
            <span class="my-auto ml-5 text-3xl text-dark-carrot font-bold" :class="animationState">
                {{ translate('Loading...') }}
            </span>
        </div>
    </div>
</template>
<script setup>
    import LoaderComponent from '@/components/Utils/LoaderComponent.vue';
    import { sleep } from '@/composables/sleep';
    import authUserService from '@/services/AuthUserService';
    import { onMounted, ref } from 'vue';
    import { useContextStore } from '@/stores/context';
    import urlHandler from '@/composables/urlHandler';
    import { useSessionMessageStore } from '@/stores/sessionMessage';
    import { translate } from '@/composables/translate';
    import Rules from '@/api/models/Rules';
    import { useAuthStore } from '@/stores/auth';

    const authStore = useAuthStore();
    const contextStore = useContextStore();
    const messageStore = useSessionMessageStore();

    onMounted(() => {
        loadAnimation();
        redirectAsExpected()
    });

    async function redirectAsExpected(){
        const requestedUrl = contextStore.getRequestedRoute;
        const requestedParams = contextStore.getRequestedRouteParams;

        const response = await authUserService.attemptLogin();
        if(response == undefined || !response.success()){
            messageStore.errorMessage(translate('not authenticated'));
            contextStore.saveIgnoreIncomingRoute(true);
            await urlHandler.redirectAndScroll('/login');
            return;
        }

        let url = requestedUrl;
        if (url == '/login' || url == '/loading' || !url) {
            url = '/dashboard';
        }
        
        if (!checkRights()) {
            await urlHandler.redirectAndScroll('/login');
            return;
        }

        await urlHandler.redirectAndScroll(url, requestedParams);
    }

    let killAnimation = ref(false);
    let animationState = ref(null);
    async function loadAnimation(){
        while(!killAnimation.value){
            await sleep(2000);
            animationState.value = [null,'fade-in'].includes(animationState.value) ? 'fade-out' : 'fade-in';
        }
    }

    function checkRights() {
        const uri = contextStore.getRequestedRoute;
    
        const rules = new Rules(authStore.getUser.status, uri);

        if (!rules.canShow()) {
            messageStore.errorMessage('route not allowed');
            contextStore.saveRequestedRoute(rules.getBaseRoute());
            urlHandler.redirectAndScroll(rules.getBaseRoute());
            return false;
        }

        return true;
    }
</script>
<style>
    .fade-in{
        opacity: 1;
        transition: 0.2s ease-in;
    }
    .fade-out{
        opacity: 0;
        transition: 0.4s ease-in;
    }
</style>